import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
/**
 * Every surface runs on one engine and differs only by prompt and allowlist, so staff can read
 * exactly what a customer or a visitor would be told. Customer goes further: the proxy runs the turn
 * as a PM on the selected company, so the data is theirs too, not just the prompt.
 */
export const SURFACES = [{
  value: 'admin',
  label: 'Admin',
  help: 'Full read access across companies'
}, {
  value: 'pm',
  label: 'Customer',
  help: 'Runs as a PM at the selected company: their tools, their data, their answers'
}, {
  value: 'marketing',
  label: 'Public',
  help: 'What a logged-out visitor sees, knowledge base only, no account data'
}, {
  value: 'support',
  label: 'Support',
  help: 'Answers grounded in the knowledge base, drafts for a human to send'
}];
export const SURFACE_STARTERS = {
  pm: ['Why did my water charge go up this month?', 'Which of my properties still need bills uploaded?', 'How is my recovery rate trending?', 'What does common area deduction mean?'],
  marketing: ['What does Livable actually do?', 'How does utility billing work with AppFolio?', 'Can I bill residents for submetered utilities?', 'How do I get started?'],
  support: ['A resident says they were double charged for water', 'How do I explain a common area deduction to a resident?', 'A customer wants to cancel, what are their options?', 'What should I tell someone whose statement looks wrong?']
};

/** The surface a logged turn ran on, as a picker value: the drawer's staff surface is Admin. */
export const surfaceFromRun = ran => {
  var _SURFACES$find$value, _SURFACES$find;
  return (_SURFACES$find$value = (_SURFACES$find = SURFACES.find(s => s.value === ran)) === null || _SURFACES$find === void 0 ? void 0 : _SURFACES$find.value) !== null && _SURFACES$find$value !== void 0 ? _SURFACES$find$value : 'admin';
};

/** The exact surface a logged turn ran on, or null when the log names none this client knows. */
export const runSurface = ran => ran === 'drawer' || SURFACES.some(s => s.value === ran) ? ran : null;

/** What a history row calls the surface a thread ran on, in the picker's words. */
export const surfaceLabel = ran => {
  var _SURFACES$find$label, _SURFACES$find2;
  return ran === 'drawer' ? 'Admin (sidebar)' : (_SURFACES$find$label = (_SURFACES$find2 = SURFACES.find(s => s.value === ran)) === null || _SURFACES$find2 === void 0 ? void 0 : _SURFACES$find2.label) !== null && _SURFACES$find$label !== void 0 ? _SURFACES$find$label : 'Admin';
};
export function LivySurfacePicker(_ref) {
  let value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    exclusive: true,
    value: value,
    disabled: disabled,
    "aria-label": "View as",
    onChange: (_, next) => {
      if (next && next !== value) onChange(next);
    }
  }, SURFACES.map(s => /*#__PURE__*/React.createElement(Tooltip, {
    key: s.value,
    title: s.help,
    placement: "bottom",
    describeChild: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: s.value,
    sx: {
      textTransform: 'none',
      px: '11px',
      py: '3px',
      fontSize: 12,
      // Selected keeps the app's own white on primary: overriding it to primary.main put
      // teal text on a teal fill and the label disappeared.
      color: 'text.secondary',
      borderColor: 'divider'
    }
  }, s.label))));
}